// extracted by mini-css-extract-plugin
export default {"numStockedItems":"StockedItemsQty_numStockedItems__xH4ke","numContainers":"StockedItemsQty_numContainers__Daylv"};